import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface HeroProps {
  onBrandClick?: () => void;
  onOrganizerClick?: () => void;
}
export function Hero({
  onBrandClick,
  onOrganizerClick
}: HeroProps) {
  return <section className="relative min-h-[85vh] flex items-center justify-center pt-20 overflow-hidden" data-id="element-758">
      {/* Background - clean solid color */}
      <div className="absolute inset-0 bg-slate-900" data-id="element-759"></div>

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center z-10" data-id="element-760">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-761">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight text-white mb-6 leading-[1.1]" data-id="element-762">
            Better matches.
            <br data-id="element-763" />
            <span className="text-slate-500" data-id="element-764">Not more sponsors.</span>
          </h1>

          <p className="text-lg md:text-xl text-slate-400 max-w-xl mx-auto mb-10" data-id="element-765">
            AI-powered sponsorship matching. Simple.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center items-center" data-id="element-766">
            <motion.button onClick={onBrandClick} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="px-8 py-4 bg-cyan-500 hover:bg-cyan-400 text-slate-900 rounded-full font-semibold text-base transition-colors flex items-center gap-2" data-id="element-767">
              I'm a Brand <ArrowRight size={18} data-id="element-768" />
            </motion.button>
            <motion.button onClick={onOrganizerClick} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="px-8 py-4 bg-slate-800 hover:bg-slate-700 text-white rounded-full font-semibold text-base transition-colors" data-id="element-769">
              I'm an Organizer
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>;
}